export const DIRECTION = {
  column: "column",
  row: "row",
};
